export function assertNotNil<T>(value: T, message?: string): NonNullable<T> {
  if (value === null || value === undefined) {
    throw new Error(message || 'Value is null or undefined')
  }
  return value as NonNullable<T>
}
